
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import {Api} from "../../utils/api"
import {Fetch} from "../../utils/storage"

export default {
name: 'UserInfo-New',
components: {
Group,
XInput,
Selector,
XButton,
XSwitch
},

async created () {
await this.fetchUserInfo()
},
data () {
return {
UserInfo:{},
nations: ['汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族', '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '僳僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
diploma: ['小学', '初中', '中专', '高中', '大专', '大学', '研究生', '博士', '博士后'],
provinces: ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区', '香港特别行政区', '澳门特别行政区', '台湾省'],
duties: ['部长','副部长','院长','副院长','局长', '副局长',  '主任', '副主任','书记','副书记','处长','副处长','科长','副科长', '科员', '主治医生', '医生', '学术研究员', '护士长', '护士', '其他'],
titles: ['副高及以上', '中级', '初级', '乡村医生', '无职称'],
}
},
methods: {
async fetchUserInfo() {
let res = await Api('GetInfo',{
})
console.log(res)
if (res.data) {
this.UserInfo = res.data
} else {
this.$vux.toast.show({
text:'获取用户信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
async handleSubmit() {
let _this = this
if (!_this.UserInfo.Name ||
!_this.UserInfo.PhoneNumber ||
!_this.UserInfo.IDCard ||
!_this.UserInfo.Email ||
!_this.UserInfo.Province ||
!_this.UserInfo.Company ||
!_this.UserInfo.Department ||
!_this.UserInfo.Duty ||
!_this.UserInfo.Title) {
_this.$vux.toast.show({
text: '必选参数不能为空',
type: 'text',
width:'3rem'
})
return
}
_this.UserInfo.Sex = _this.UserInfo.Sex === '男' ? 1 : 2
_this.UserInfo.UserID = Fetch('ID')
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">确认修改信息？</span>`,
confirmText:"确认",
cancelText:"取消",
async onConfirm(){
try {
delete _this.UserInfo.CreatedAt
delete _this.UserInfo.UpdatedAt
await Api('UpdateUserInfo',_this.UserInfo)
_this.$vux.toast.show({
text: '修改信息成功',
type: 'text',
width:'3rem'
})
_this.$router.go(-1)
}catch(err) {
_this.$vux.toast.show({
text: '添加信息失败',
type: 'cancel',
width:'3rem'
})
}
}
})
}
},
}
